import { Config } from '@/config';
import { ApiService } from '@/services/api.service';
import { formatDate } from '@/util/date-util';
import moment from 'moment';
import axios from 'axios';

const CancelToken = axios.CancelToken;
let cancelTokens = {
  evaluationGrid: null,
};

class EvaluationGridService {
  getEvaluationGrid({ opportunityId }) {
    if (cancelTokens.evaluationGrid) cancelTokens.evaluationGrid.cancel('Multiple requests.');
    cancelTokens.evaluationGrid = CancelToken.source();

    return ApiService.get(`${Config.api.document.url}api/v1/opportunities/${opportunityId}/evaluation-grid`, {
      cancelToken: cancelTokens.evaluationGrid.token,
    }).then((response) => {
      const evaluationGrid = response.data;
      const { fields } = evaluationGrid;
      this.formattedValue(fields);
      return evaluationGrid;
    });
  }

  formattedValue(fields) {
    fields.forEach((field) => {
      const { values } = field;
      values.forEach((value) => {
        if (value.source === 'ALOHA_TENDERS') {
          const utcDate = moment.utc(value.value, 'YYYY-MM-DD HH:mm:ss');
          if (utcDate.isValid()) {
            value.value = formatDate(utcDate, 'ddd ll HH:mm:ss z');
          }
        }
      });
    });
  }

  // Manipulating evaluation grid values
  addEvalGridValue({ opportunityId, fieldId, source, textAnnotationId, opportunityDocumentId, value, valueType }) {
    const data = {
      source,
      textAnnotationId,
      opportunityDocumentId,
      value,
      valueType,
    };

    return ApiService.post(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/evaluation-grid/fields/${fieldId}/values`,
      data,
    ).then((response) => response.data);
  }

  updateEvalGridValue({ opportunityId, fieldId, id, valueType }) {
    const data = { valueType };
    return ApiService.put(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/evaluation-grid/fields/${fieldId}/values/${id}`,
      data,
    ).then((response) => response.data);
  }

  deleteEvalGridValue({ opportunityId, fieldId, id }) {
    return ApiService.delete(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/evaluation-grid/fields/${fieldId}/values/${id}`,
    ).then((response) => response.data);
  }

  addEvalGridField({ opportunityId, field }) {
    return ApiService.post(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/evaluation-grid/fields`,
      field,
    ).then((response) => response.data);
  }

  updateEvalGridField({ opportunityId, fieldId, newField }) {
    return ApiService.put(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/evaluation-grid/fields/${fieldId}`,
      newField,
    ).then((response) => response.data);
  }

  deleteEvalGridField({ opportunityId, fieldId }) {
    return ApiService.delete(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/evaluation-grid/fields/${fieldId}`,
    ).then((response) => response.data);
  }
  uploadEvalGridValueImage({ opportunityId, fieldId, formData }) {
    return ApiService.post(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/evaluation-grid/fields/${fieldId}/values/upload`,
      formData,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        },
      },
    ).then((response) => response.data);
  }
}

export const evaluationGridService = new EvaluationGridService();
